import { STORAGE_KEYS } from "../config/constants";

/**
 * Utilitaires pour le localStorage
 */
export const storage = {
  /**
   * Récupère une valeur du localStorage
   */
  get(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Erreur lors de la lecture de ${key}:`, error);
      return null;
    }
  },

  /**
   * Sauvegarde une valeur dans le localStorage
   */
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Erreur lors de l'écriture de ${key}:`, error);
    }
  },

  /**
   * Supprime une valeur du localStorage
   */
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Erreur lors de la suppression de ${key}:`, error);
    }
  },

  /**
   * Récupère une valeur string (sans JSON.parse)
   */
  getString(key) {
    return localStorage.getItem(key);
  },

  /**
   * Sauvegarde une valeur string (sans JSON.stringify)
   */
  setString(key, value) {
    localStorage.setItem(key, value);
  },

  /**
   * Nettoie toutes les clés liées à l'authentification
   */
  clearAuth() {
    Object.values(STORAGE_KEYS).forEach((key) => {
      if (key !== STORAGE_KEYS.SELECTED_REWARD_ID) {
        this.remove(key);
      }
    });
  },

  /**
   * Nettoie les données Twitch
   */
  clearTwitch() {
    this.remove(STORAGE_KEYS.TWITCH_USER);
    this.remove(STORAGE_KEYS.TWITCH_TOKEN);
  },

  /**
   * Nettoie les données Spotify
   */
  clearSpotify() {
    this.remove(STORAGE_KEYS.SPOTIFY_USER);
    this.remove(STORAGE_KEYS.SPOTIFY_TOKEN);
    this.remove(STORAGE_KEYS.SPOTIFY_LOGOUT_IN_PROGRESS);
  },
};
